import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useClient } from "../../context/ClientProvider";
import ListAltIcon from "@mui/icons-material/ListAlt";
import LinkIcon from "@mui/icons-material/Link";
import ScrollToTopButton from "../ScrollToTopButton";
const Footer = () => {
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();
  const urlToUnauthPageKey = {
    "/contact-us": "contactUs",
    "/ways-to-pay": "findWaysToPay",
    "/useful-tips": "usefulTips",
  };

  return clientConfig && (
    <>
      <ScrollToTopButton /> 
      <Box
        component='footer'
        sx={{
          color: {
            xs: clientConfig.layout.footer.mobileColour,
            md: clientConfig.layout.footer.colour
          },
          backgroundColor: {
            xs: clientConfig.layout.footer.mobileBackgroundColour,
            md: clientConfig.layout.footer.backgroundColour
          }
        }}
      >
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{
            pt: { xs: 5, md: 10 },
            px: { xs: 2, md: 10 },
          }}
        >
          {clientConfig.layout &&
            clientConfig.layout.footer.sections.map((item, idx) => {
              return (
                <Grid
                  id={`footer-${item.title
                    .replace(" ", "-")
                    .toLowerCase()}-column`}
                  key={idx}
                  item
                  xs={6}
                  md={3}
                >
                  <Typography
                    variant='h6'
                    component='div'
                    marginRight={3.75}
                    fontWeight={600}
                  >
                    {idx === 0 ? (
                      <ListAltIcon sx={{ marginRight: "5px" }} />
                    ) : (
                      <LinkIcon
                        sx={{ marginRight: "5px", marginBottom: "5px" }}
                      />
                    )}
                    {item.title}
                  </Typography>
                  <List dense>
                    {item.links
                      .filter((link) => {
                        const unauthPages = clientConfig.layout.unauthenticatedPages || {};
                        const pageKey = urlToUnauthPageKey[link.url];
                        return !pageKey || unauthPages[pageKey]?.enabled;
                      })
                      .map((link, idx) => (
                        <ListItem key={idx}>
                          <ListItemButton
                            component='a'
                            href={link.url}
                            target='_blank'
                            sx={{ height: "28px" }}
                          >
                            <ListItemText primary={link.label} />
                          </ListItemButton>
                        </ListItem>
                      ))}

                  </List>
                </Grid>
              );
            })}
        </Grid>
        <Box sx={{ py: 5, px: { xs: 5, md: 10 } }}>
          <Typography sx={{ fontSize: 14, fontStyle: "italic", mb: 2 }}>
            {clientConfig.layout.footer.footerNoteOne}
          </Typography>
          <Typography fontSize={14} fontStyle={"italic"}>
            {clientConfig.layout.footer.footerNoteTwo}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
